/**
 * Kanews ikonları
 */
export const kanewsIcons = [
    { label: 'Arama', value: 'icon-search' },
    { label: 'Zarf', value: 'icon-envelope' },
    { label: 'Kullanıcı', value: 'icon-user' },
    { label: 'Ana Sayfa', value: 'icon-home' },
    { label: 'Ekle', value: 'icon-add' },
    { label: 'Galeri', value: 'icon-gallery' },
    { label: 'Değişim', value: 'icon-exchange' },
    { label: 'Düzenle', value: 'icon-edit' },
    { label: 'Yerel', value: 'icon-local' },
    { label: 'Konum', value: 'icon-location' },
    { label: 'Pin', value: 'icon-pin' },
    { label: 'Telefon', value: 'icon-call' },
    { label: 'Yorum', value: 'icon-comment' },
    { label: 'Anahtar', value: 'icon-vpn_key' },
    { label: 'Menü', value: 'icon-menu' },
    { label: 'Menü 2', value: 'icon-menu2' },
    { label: 'Canlı', value: 'icon-live' },
    { label: 'Yıldız', value: 'icon-star' },
    { label: 'Yıldız (Boş)', value: 'icon-star-o' },
    { label: 'Yarım Yıldız', value: 'icon-star-half' },
    { label: 'Yer İmi', value: 'icon-bookmark' },
    { label: 'Yer İmi (Boş)', value: 'icon-bookmark-o' },
    { label: 'Tamamlandı', value: 'icon-done' },
    { label: 'Ayarlar', value: 'icon-settings' },
    { label: 'Beğen', value: 'icon-like' },
    { label: 'Beğen (Boş)', value: 'icon-like-o' },
    { label: 'Çıkış', value: 'icon-logout' },
    { label: 'Sıralama', value: 'icon-standings' },
    { label: 'Makale', value: 'icon-article' },
    { label: 'Covid', value: 'icon-covid' },
    { label: 'Ok', value: 'icon-caret' },
    { label: 'Uzun Ok', value: 'icon-arrow-long' },
    { label: 'Ok', value: 'icon-arrow' },
    { label: 'Video', value: 'icon-video' },
    { label: 'Mikrofon', value: 'icon-mic' },
    { label: 'Bildirimler', value: 'icon-notifications' },
    { label: 'Görüntüle', value: 'icon-view' },
    { label: 'Izgara', value: 'icon-grid' },
    { label: 'Şimşek', value: 'icon-bolt' },
    { label: 'Tumblr', value: 'icon-tumblr' },
    { label: 'Kapat', value: 'icon-close' },
    { label: 'Kilidi Aç', value: 'icon-unlock' },
    { label: 'Ay (Dolu)', value: 'icon-moon-fill' },
    { label: 'Hava Durumu', value: 'icon-weather' },
    { label: 'Alıntı', value: 'icon-quotes-left' },
    { label: 'Güneş', value: 'icon-sun' },
    { label: 'Facebook', value: 'icon-facebook' },
    { label: 'Instagram', value: 'icon-instagram' },
    { label: 'WhatsApp', value: 'icon-whatsapp' },
    { label: 'Twitter', value: 'icon-twitter' },
    { label: 'YouTube', value: 'icon-youtube' },
    { label: 'LinkedIn', value: 'icon-linkedin' },
    { label: 'Pinterest', value: 'icon-pinterest' },
    { label: 'Trafik', value: 'icon-traffic' },
    { label: 'Paylaş', value: 'icon-share' },
    { label: 'Bitcoin', value: 'icon-bitcoin' },
    { label: 'Para', value: 'icon-money' },
    { label: 'Gazete', value: 'icon-newspaper' },
    { label: 'Telegram', value: 'icon-telegram' },
    { label: 'Eczane', value: 'icon-local_pharmacy' },
    { label: 'Tip', value: 'icon-type' },
    { label: 'Abonelikler', value: 'icon-subscriptions' }
];

export const Icons = {
    reset: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" />
        </svg>
    ),
    alignLeft: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path d="M9 9v6h11V9H9zM4 20h1.5V4H4v16z" />
        </svg>
    ),
    alignCenter: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path d="M20 9v6H4V9h16zm-3 4H7v-2h10v2z" />
        </svg>
    ),
    alignRight: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path d="M4 9v6h11V9H4zm16 11h-1.5V4H20v16z" />
        </svg>
    ),
    alignJustify: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path d="M4 9h16v2H4V9zm0 4h16v2H4v-2z" />
        </svg>
    ),
    desktop: (
        <svg width="16" height="16" viewBox="0 0 24 24">
            <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h6l-2 2v1h8v-1l-2-2h6c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z" />
        </svg>
    ),
    tablet: (
        <svg width="16" height="16" viewBox="0 0 24 24">
            <path d="M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z" />
        </svg>
    ),
    mobile: (
        <svg width="16" height="16" viewBox="0 0 24 24">
            <path d="M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z" />
        </svg>
    )
}; 